import "core-js/modules/es.array.push.js";
import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed font-mono z-10 left-0 top-0"
};
const _hoisted_2 = {
  class: "bg-[#5b5b5b70] w-[100vw] h-[100vh] sticky pt-0 flex justify-center"
};
const _hoisted_3 = {
  style: {
    "box-shadow": "0 8px 20px rgba(0,0,0,.6)"
  },
  class: "bg-slate-950 rounded-2xl w-[28rem] md:w-[40rem] h-[50vh] md:h-[70vh] top-[20vh] md:top-[10vh] relative shadow-md flex flex-col items-center overflow-y-auto pb-2 text-white"
};
const _hoisted_4 = {
  class: "w-5/6 pt-4 flex item-center flex-col text-left"
};
const _hoisted_5 = {
  class: "h-[3rem] w-full pt-3 flex justify-between items-center mb-8"
};
const _hoisted_6 = {
  class: "text-2xl text-white mr-4"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "i-mdi-close"
}, null, -1);
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "flex flex-col"
};
const _hoisted_10 = {
  class: "text-2xl mt-1 mb-4"
};
const _hoisted_11 = {
  class: "mb-3 flex flex-row justify-between"
};
const _hoisted_12 = {
  class: "w-[50%] p-2 flex flex-col"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
  class: "flex space-x-3 items-center"
};
const _hoisted_15 = {
  key: 0,
  role: "status"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "inline w-8 h-8 text-gray-600 animate-spin dark:text-gray-600 fill-pink-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
})], -1);
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "sr-only"
}, "Loading...", -1);
const _hoisted_18 = [_hoisted_16, _hoisted_17];
const _hoisted_19 = {
  key: 1,
  class: "text-pink-600 text-xl"
};
const _hoisted_20 = {
  class: "text-base font-normal text-gray-400 mb-1"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "text-2xl mt-1 mb-4"
};
const _hoisted_23 = {
  class: "mb-3"
};
const _hoisted_24 = {
  class: "flex items-center mb-4"
};
const _hoisted_25 = {
  class: "text-2xl"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  class: "i-mdi-add scale-120"
}, null, -1);
const _hoisted_27 = [_hoisted_26];
const _hoisted_28 = {
  key: 0,
  class: "text-base text-gray-700"
};
const _hoisted_29 = {
  class: "flex flex-col space-y-2"
};
const _hoisted_30 = {
  class: "flex items-center"
};
const _hoisted_31 = ["onUpdate:modelValue"];
const _hoisted_32 = ["onUpdate:modelValue"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  class: "i-mdi-rubbish-bin scale-150"
}, null, -1);
const _hoisted_35 = [_hoisted_34];
const _hoisted_36 = {
  class: "text-2xl mt-4 mb-4"
};
const _hoisted_37 = {
  class: "text-base font-normal text-gray-400 mb-4"
};
const _hoisted_38 = {
  class: "flex flex-col space-y-4"
};
const _hoisted_39 = {
  class: "flex w-full items-center"
};
const _hoisted_40 = {
  class: "mr-4"
};
const _hoisted_41 = {
  class: "flex w-full items-center"
};
const _hoisted_42 = {
  class: "mr-4"
};
const _hoisted_43 = {
  class: "text-2xl mt-4 mb-4"
};
const _hoisted_44 = {
  class: "flex flex-col space-y-4"
};
const _hoisted_45 = {
  class: "flex w-full items-center"
};
const _hoisted_46 = {
  class: "mr-4"
};
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", {
  class: "i-mdi-add scale-150"
}, null, -1);
const _hoisted_48 = [_hoisted_47];
const _hoisted_49 = {
  class: "mt-4 grid grid-flow-row-dense grid-cols-4 grid-rows-3 gap-3"
};
const _hoisted_50 = {
  class: "bg-slate-400 px-2 py-1 text-black flex items-center transition-all justify-between"
};
const _hoisted_51 = ["onClick"];
const _hoisted_52 = {
  class: "text-2xl mt-4 mb-4"
};
const _hoisted_53 = {
  class: "text-base font-normal text-gray-400 mb-4"
};
const _hoisted_54 = {
  class: "flex flex-col space-y-4 mb-4"
};
const _hoisted_55 = {
  class: "flex w-full items-center"
};
const _hoisted_56 = {
  class: "mr-4 w-[6rem]"
};
const _hoisted_57 = {
  class: "flex w-full items-center"
};
const _hoisted_58 = {
  class: "mr-4 w-[6rem]"
};
const _hoisted_59 = {
  key: 0,
  class: "text-pink-600 text-xl mt-2 mb-2"
};
const _hoisted_60 = {
  key: 1,
  class: "text-xl font-bold mb-4 text-pink-600"
};
const _hoisted_61 = ["disabled"];
const _hoisted_62 = {
  key: 0,
  role: "status"
};
const _hoisted_63 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "inline w-8 h-8 text-gray-600 animate-spin dark:text-gray-600 fill-pink-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
})], -1);
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", {
  class: "sr-only"
}, "Loading...", -1);
const _hoisted_65 = [_hoisted_63, _hoisted_64];
const _hoisted_66 = {
  key: 1
};
import { uploadFileToIPFS, uploadObjectToIPFS } from '@/ipfs';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetadataEditor',
  props: {
    "show_model": {
      type: Boolean
    },
    "show_modelModifiers": {},
    "meta_forms": {},
    "meta_formsModifiers": {},
    "token_uri": {},
    "token_uriModifiers": {},
    "token_name": {},
    "token_nameModifiers": {},
    "symbol": {},
    "symbolModifiers": {}
  },
  emits: ["update:show_model", "update:meta_forms", "update:token_uri", "update:token_name", "update:symbol"],
  setup(__props) {
    const {
      t
    } = useI18n();
    const show_meta_model = _useModel(__props, "show_model");
    const meta_status = ref({
      image_uploading: false,
      image_uploading_msg: "",
      meta_uploading: false,
      meta_uploading_msg: ""
    });
    const meta_forms = _useModel(__props, "meta_forms");
    const token_uri = _useModel(__props, "token_uri");
    const token_name = _useModel(__props, "token_name");
    const symbol = _useModel(__props, "symbol");
    async function handleUploadImageFile(file) {
      if (meta_status && meta_status.value && meta_forms.value) {
        meta_status.value.image_uploading = true;
        meta_status.value.image_uploading_msg = t("messages.uploading");
        let upload_result = undefined;
        try {
          upload_result = await uploadFileToIPFS(file);
          console.log(`upload_result: ${upload_result}`);
        } catch (e) {
          meta_status.value.image_uploading_msg = t("messages.uploadError", {
            errorMessage: e.toString()
          });
        }
        if (upload_result) {
          meta_status.value.image_uploading_msg = t("messages.uploadComplete");
          meta_forms.value.image = upload_result;
        }
        meta_status.value.image_uploading = false;
      }
    }
    async function clickUpdateMeta() {
      if (meta_status && meta_status.value && meta_forms.value) {
        meta_status.value.meta_uploading = true;
        meta_status.value.meta_uploading_msg = t("messages.uploading");
        let upload_result = undefined;
        let pin_object = {
          name: token_name,
          symbol: symbol,
          extensions: {},
          image: meta_forms.value.image,
          creator: meta_forms.value.creator.name == "" && meta_forms.value.creator.site == "" ? {} : meta_forms.value.creator,
          description: meta_forms.value.description,
          tags: meta_forms.value.tags
        };
        if (meta_forms.value.extension_keys.length > 0) {
          let extension_obj = {};
          meta_forms.value.extension_keys.forEach((_, index) => {
            if (meta_forms.value) {
              extension_obj[meta_forms.value.extension_keys[index]] = meta_forms.value.extension_values[index];
            }
          });
          pin_object["extensions"] = extension_obj;
        }
        try {
          upload_result = await uploadObjectToIPFS(pin_object);
        } catch (e) {
          meta_status.value.meta_uploading_msg = t("messages.uploadError", {
            errorMessage: e.toString()
          });
        }
        if (upload_result) {
          console.log(`upload_result: ${upload_result}`);
          meta_status.value.meta_uploading_msg = t("messages.uploadComplete");
          token_uri.value = upload_result;
        }
        meta_status.value.meta_uploading = false;
        show_meta_model.value = false;
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [show_meta_model.value && meta_status.value && meta_forms.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("titles.createMetadata")), 1), _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = $event => show_meta_model.value = false),
          class: "absolute right-[2rem] h-[1.5rem] w-[1.5rem] bg-[#1c2338] rounded-[50%] scale-[1.5] flex justify-center items-center text-slate-400 hover:text-slate-200 cursor-pointer transition-colors"
        }, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("labels.metadataImage")), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("input", {
          onChange: _cache[1] || (_cache[1] = async e => {
            if (e.target) {
              let target = e.target;
              if (target.files && target.files && target.files.length && target.files.length > 0) {
                await handleUploadImageFile(target.files[0]);
              }
            }
          }),
          disabled: meta_status.value.image_uploading,
          accept: "image/*",
          class: "relative m-0 bg-slate-800 mb-2 block w-full min-w-0 cursor-pointer bg- bg-clip-padding px-3 py-[0.32rem] text-base font-normal text-surface transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:me-3 file:cursor-pointer file:overflow-hidden file:rounded-none file:border-0 file:border-e file:border-solid file:border-inherit file:bg-transparent file:px-3 file:py-[0.32rem] file:text-surface focus:border-primary focus:text-gray-700 focus:shadow-inset focus:outline-none dark:border-white/70 dark:text-white file:dark:text-white",
          type: "file"
        }, null, 40, _hoisted_13), _createElementVNode("div", _hoisted_14, [meta_status.value.image_uploading ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18)) : _createCommentVNode("", true), meta_status.value.image_uploading_msg != '' ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(meta_status.value.image_uploading_msg), 1)) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("hints.metadataImage")), 1)]), _createElementVNode("div", {
          class: _normalizeClass(["max-h-[20rem] max-w-[50%] bg-slate-600 flex justify-center", meta_forms.value.image == '' ? '' : 'p-2'])
        }, [meta_forms.value.image != '' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "max-w-[100%] max-h-[100%] object-cover",
          src: meta_forms.value.image
        }, null, 8, _hoisted_21)) : _createCommentVNode("", true)], 2)]), _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("labels.metadataDescription")), 1), _createElementVNode("div", _hoisted_23, [_withDirectives(_createElementVNode("textarea", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => meta_forms.value.description = $event),
          class: "text-white block w-full p-4 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600"
        }, null, 512), [[_vModelText, meta_forms.value.description]])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("labels.metadataExtensions")), 1), _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = () => {
            var _meta_forms$value, _meta_forms$value2;
            (_meta_forms$value = meta_forms.value) === null || _meta_forms$value === void 0 ? void 0 : _meta_forms$value.extension_keys.push('');
            (_meta_forms$value2 = meta_forms.value) === null || _meta_forms$value2 === void 0 ? void 0 : _meta_forms$value2.extension_values.push('');
          }),
          class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 px-1 rounded flex items-center transition-colors ml-5"
        }, _hoisted_27)]), meta_forms.value.extension_keys.length == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t("messages.metadataNoExtension")), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meta_forms.value.extension_values, (_, index) => {
          return _openBlock(), _createElementBlock("div", _hoisted_30, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => meta_forms.value.extension_keys[index] = $event,
            type: "text",
            class: "text-white block w-4/12 p-2 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600 mr-2"
          }, null, 8, _hoisted_31), [[_vModelText, meta_forms.value.extension_keys[index]]]), _createTextVNode(" : "), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => meta_forms.value.extension_values[index] = $event,
            type: "text",
            class: "text-white block w-4/12 p-2 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600 ml-2"
          }, null, 8, _hoisted_32), [[_vModelText, meta_forms.value.extension_values[index]]]), _createElementVNode("button", {
            onClick: () => {
              var _meta_forms$value3, _meta_forms$value4;
              (_meta_forms$value3 = meta_forms.value) === null || _meta_forms$value3 === void 0 ? void 0 : _meta_forms$value3.extension_keys.splice(index, 1);
              (_meta_forms$value4 = meta_forms.value) === null || _meta_forms$value4 === void 0 ? void 0 : _meta_forms$value4.extension_values.splice(index, 1);
            },
            class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-2 px-3 rounded flex items-center transition-colors ml-5"
          }, _hoisted_35, 8, _hoisted_33)]);
        }), 256))]), _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("labels.metadataCreatorInfo")), 1), _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("messages.metadataKeepCreatorNoneTip")), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("labels.metadataCreatorName")) + ": ", 1), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => meta_forms.value.creator.name = $event),
          type: "text",
          class: "text-white block flex-1 p-2 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600 mr-2"
        }, null, 512), [[_vModelText, meta_forms.value.creator.name]])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("labels.metadataCreatorSite")) + ": ", 1), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => meta_forms.value.creator.site = $event),
          type: "text",
          class: "text-white block flex-1 p-2 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600 mr-2"
        }, null, 512), [[_vModelText, meta_forms.value.creator.site]])])]), _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('labels.metadataTags')), 1), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('hints.metadataNewTag')) + ": ", 1), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => meta_forms.value.now_input_tag = $event),
          type: "text",
          class: "text-white block flex-1 p-2 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600 mr-2"
        }, null, 512), [[_vModelText, meta_forms.value.now_input_tag]]), _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = () => {
            if (meta_forms.value) {
              meta_forms.value.now_input_tag != '' && meta_forms.value.tags.findIndex(v => {
                var _meta_forms$value5;
                return v == ((_meta_forms$value5 = meta_forms.value) === null || _meta_forms$value5 === void 0 ? void 0 : _meta_forms$value5.now_input_tag);
              }) ? meta_forms.value.tags.push(meta_forms.value.now_input_tag) : '';
            }
          }),
          class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-2 px-2 rounded flex items-center transition-colors ml-5 h-full"
        }, _hoisted_48)])]), _createElementVNode("div", _hoisted_49, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meta_forms.value.tags, (tag, index) => {
          return _openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("span", null, _toDisplayString(tag), 1), _createElementVNode("span", {
            onClick: () => {
              var _meta_forms$value6;
              (_meta_forms$value6 = meta_forms.value) === null || _meta_forms$value6 === void 0 ? void 0 : _meta_forms$value6.tags.splice(index, 1);
            },
            class: "i-mdi-close ml-2 cursor-pointer hover:text-pink-600"
          }, null, 8, _hoisted_51)]);
        }), 256))])]), _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("labels.tokenInfo")), 1), _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t("messages.metadataKeepCreatorNoneTip")), 1), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("labels.tokenName")) + ": ", 1), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => token_name.value = $event),
          type: "text",
          class: "text-white block flex-1 p-2 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600 mr-2"
        }, null, 512), [[_vModelText, token_name.value]])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t("labels.tokenSymbol")) + ": ", 1), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => symbol.value = $event),
          type: "text",
          class: "text-white block flex-1 p-2 bg-slate-800 border-0 rounded-0 text-base focus:ring-pink-500 focus:border-pink-600 mr-2"
        }, null, 512), [[_vModelText, symbol.value]])])]), meta_status.value.meta_uploading_msg != '' ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(meta_status.value.meta_uploading_msg), 1)) : _createCommentVNode("", true), token_name.value == '' || symbol.value == '' ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t('errors.emptyTokenNameOrSymbol')), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
          disabled: meta_status.value.meta_uploading,
          onClick: clickUpdateMeta,
          class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-2 px-4 rounded items-center mt-7 w-full transition-colors mb-5 text-lg"
        }, [meta_status.value.meta_uploading ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_65)) : _createCommentVNode("", true), !meta_status.value.meta_uploading ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.$t("actions.updateMetadata")), 1)) : _createCommentVNode("", true)], 8, _hoisted_61)])])])])) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
});